import { gql } from "@apollo/client";
const SET_DEFAULT_LOCATION_MUTATION = gql(`
  mutation SetDefaultLocation($id: UUID!) {
    setDefaultLocation(input: { id: $id }) {
      locationPerson {
        id
        type
        location {
          id
        }
      }
    }
  }
`);

export {SET_DEFAULT_LOCATION_MUTATION}